import { useCallback } from 'react';

import { LobbyType } from '../api/fetchers/slots/types';
import { fetchSlotsOpenUrlAction } from '../store/apiActions/fetchSlotsOpenUrlAction';
import { useCoreDispatch } from '../store/CoreStore';
import { useConfigSlice } from '../store/slices/config/selectors';

export const useSlotsRedirectFunction = (showBackToGame: boolean = false): (() => void) => {
  const dispatch = useCoreDispatch();

  const isSlotsLobby = useConfigSlice.getIsSlotsLobby();
  const baseUrl = useConfigSlice.baseUrl();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const operatorGameId = useConfigSlice.tableConfig()?.operatorGameId ?? '';

  const handleSlotRedirect = useCallback(() => {
    if (!baseUrl || !JSESSIONID || !isSlotsLobby) return;

    const overrideParams = {
      lobbyGameSymbol: showBackToGame ? operatorGameId : '',
    };

    dispatch(
      fetchSlotsOpenUrlAction({
        baseUrl,
        JSESSIONID,
        lobbyType: LobbyType.SLOTSLOBBY,
        overrideParams,
      })
    );
  }, [dispatch, baseUrl, JSESSIONID, isSlotsLobby, showBackToGame, operatorGameId]);

  return handleSlotRedirect;
};
